// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3m57e","description":"PatientConsentPreview_description__2-ugn"};